class VehicleStageController {}

module.exports = VehicleStageController
